import type { MarlinStoreDb } from "../infra/db";
import * as ops from "./store";

export const createTemplatesApi = (db: MarlinStoreDb) => ({
  getMultiScreenLayoutTemplates: () => ops.getMultiScreenLayoutTemplates(db),
  getMultiScreenLayoutTemplate: (
    templateId: Parameters<typeof ops.getMultiScreenLayoutTemplate>[1],
  ) => ops.getMultiScreenLayoutTemplate(db, templateId),
  saveMultiScreenLayoutTemplate: (
    name: Parameters<typeof ops.saveMultiScreenLayoutTemplate>[1],
  ) => ops.saveMultiScreenLayoutTemplate(db, name),
  deleteMultiScreenLayoutTemplate: (
    templateId: Parameters<typeof ops.deleteMultiScreenLayoutTemplate>[1],
  ) => ops.deleteMultiScreenLayoutTemplate(db, templateId),
  loadMultiScreenLayoutTemplate: (
    templateId: Parameters<typeof ops.loadMultiScreenLayoutTemplate>[1],
  ) => ops.loadMultiScreenLayoutTemplate(db, templateId),
  getSelectedTemplateId: () => ops.getSelectedTemplateId(db),
  setSelectedTemplateId: (
    templateId: Parameters<typeof ops.setSelectedTemplateId>[1],
  ) => ops.setSelectedTemplateId(db, templateId),
  getLastTemplateLoad: () => ops.getLastTemplateLoad(db),
});

export type TemplatesApi = ReturnType<typeof createTemplatesApi>;
